/** Customer (shopper) session helpers — never treats admin panel token as a shopper session. */

export const AUTH_REQUIRED_MESSAGE = 'Please login or create an account to continue.';

export function getCustomerToken(): string | null {
  return localStorage.getItem('token');
}

export function getCustomerUser(): { role?: string } | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function isCustomerAuthenticated(): boolean {
  const token = getCustomerToken();
  const user = getCustomerUser();
  if (!token || !user) return false;
  return user.role !== 'admin';
}
